// NewFAQ.jsx

import React, { useEffect, useState } from "react";
import "./NewFAQ.css";
import { FaPlus, FaMinus } from "react-icons/fa6";
import HomeService from "../../../Services/HomeService";

const NewFAQ = () => {

  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const fetchFaqs = async () => {
    try {

      const res = await HomeService?.getFaqs();

      if (res?.status) {
        setFaqs(res?.data);
      }

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="luxfaq-main-section">

      <div className="luxfaq-glow-one"></div>
      <div className="luxfaq-glow-two"></div>

      <div className="luxfaq-container">

        {/* TOP */}

        <div className="luxfaq-top-wrapper">

          <span className="luxfaq-subtitle">
            Frequently Asked Questions
          </span>

          <h2 className="luxfaq-title">
            Everything You Need
            To Know Before Getting Started
          </h2>

          <p className="luxfaq-description">
            Explore answers to the most common questions
            about our services, platform experience,
            investment process, and support system.
          </p>

        </div>

        {/* FAQ */}

        <div className="luxfaq-wrapper">

          {faqs?.map((e, i) => (

            <div
              key={i}
              className={`luxfaq-item ${
                activeIndex === i ? "luxfaq-active" : ""
              }`}
            >

              <button
                className="luxfaq-question"
                onClick={() => toggleFaq(i)}
              >

                <span>
                  {e?.question}
                </span>

                <div className="luxfaq-icon">

                  {activeIndex === i ? (
                    <FaMinus />
                  ) : (
                    <FaPlus />
                  )}

                </div>

              </button>

              <div
                className={`luxfaq-answer-wrapper ${
                  activeIndex === i
                    ? "luxfaq-answer-show"
                    : ""
                }`}
              >

                <div className="luxfaq-answer">
                  {e?.answer}
                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default NewFAQ;